package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class MedicalRecordSignSymptomSeverity(private val literal: String) : IEnumType {
	轻("轻"),
	中("中"),
	重("重");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "medical_record_sign_symptom_severity"}
	override fun getLiteral(): String {return literal}
}
